import { useContext } from "react"
import { AppMainContext } from "../context/AppMainContext";
import { useNavigate } from "react-router-dom";


export default function ResetTasks() {
  const {handleResetTasks, resetFlag} = useContext(AppMainContext);
  const nav = useNavigate();
  return (
    <div className="resetTask_div">
      <button className="resetTask_btn" disabled={resetFlag} onClick={()=>{handleResetTasks(nav)}}>{resetFlag ? "המתן..." : "התחל יום חדש"}</button>
    </div>
  )
}
